import { isMacOs } from "react-device-detect";

import { Box, Typography, Divider } from "@mui/material";

import { grayLight } from "design-system/colors";

const TOOLTIP_MAX_WIDTH = 350;

const EmailEditorTips = () => {
  const undoRedoTip = isMacOs
    ? "Undo (⌘Z) / Redo (⌘⇧Z) available during editing"
    : "Undo (Ctrl+Z) / Redo (Ctrl+Y) available during editing";

  const tipSections = [
    {
      title: "Smart Keys (Merge Tags)",
      tips: [
        "Use @ to autocomplete merge tags in the editor",
        "Merge Tags can be used in button URL fields",
      ],
    },
    {
      title: "Design Tips",
      tips: [
        "Templates are mobile-responsive by default",
        "Use preview mode to test different devices",
        "Keep images under 1MB for best performance",
      ],
    },
    {
      title: "Templates",
      tips: ["Save your custom designs for reuse", undoRedoTip],
    },
  ];

  return (
    <Box maxWidth={TOOLTIP_MAX_WIDTH} p={1}>
      <Typography variant="body2" fontWeight="600" gutterBottom>
        Email Editor Tips & Tricks
      </Typography>

      <Divider sx={{ my: 1, borderColor: grayLight }} />

      {tipSections.map((section, index) => {
        const isLastSection = index === tipSections.length - 1;

        return (
          <Box key={section.title} sx={{ mb: isLastSection ? 0 : 1.5 }}>
            <Typography
              variant="caption"
              fontWeight="500"
              display="block"
              gutterBottom
            >
              {section.title}
            </Typography>
            <Box pl={1} display="flex" flexDirection="column" gap={0.5}>
              <Typography variant="caption">
                {section.tips.map((tip, tipIndex) => {
                  const isLastTip = tipIndex === section.tips.length - 1;

                  return (
                    <span key={tipIndex}>
                      • {tip}
                      {!isLastTip && <br />}
                    </span>
                  );
                })}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default EmailEditorTips;
